const apiUrl = process.env.IDA_API_URL;

async function readMessage(response, fallback) {
  try {
    const body = await response.json();
    return body?.message || fallback;
  } catch (e) {
    return fallback;
  }
}

export async function loginWithPassword(email, password) {
  const response = await fetch(`${apiUrl}/customer/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password }),
  });

  if (!response.ok) {
    throw new Error(await readMessage(response, "signin-failed"));
  }

  return response.json();
}

export async function requestPasswordReset(email) {
  const response = await fetch(`${apiUrl}/customer/password/forgot`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email }),
  });

  const message = await readMessage(response, "general");
  if (!response.ok) {
    throw new Error(message);
  }
  return message;
}

export async function resetPassword(email, code, newPassword) {
  const response = await fetch(`${apiUrl}/customer/password/reset`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, code, newPassword }),
  });

  const message = await readMessage(response, "general");
  if (!response.ok) {
    throw new Error(message);
  }
  return message;
}

export async function refreshSession(accessToken, refreshToken) {
  const response = await fetch(`${apiUrl}/bankid/refreshtoken`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ accessToken, refreshToken }),
  });

  if (!response.ok) {
    throw new Error(await readMessage(response, "general"));
  }

  return response.json();
}

export function decodeToken(token) {
  const payload = token.split(".")[1];
  const normalised = payload.replace(/-/g, "+").replace(/_/g, "/");
  const json = decodeURIComponent(
    atob(normalised)
      .split("")
      .map((c) => `%${c.charCodeAt(0).toString(16).padStart(2, "0")}`)
      .join("")
  );
  return JSON.parse(json);
}
